import { forwardRef } from 'react';

import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';
import { TextInput } from '@bambi/component-library/src/components/inputs/TextInput/TextInput';

import { FormFieldProps } from './FormField';

export const FormFieldDefault = forwardRef<
  HTMLInputElement,
  FormFieldProps<any>
>(function FormFieldDefault<T>(
  {
    inputProps,
    label,
    error,
    type,
    helperText,
    className,
    inline,
    highlight,
  }: FormFieldProps<T>,
  ref: React.Ref<HTMLInputElement>
) {
  return (
    <DefaultFormFieldLayout
      label={label}
      error={error}
      inputId={inputProps.id}
      className={className}
      inline={inline}
      helperText={helperText}
    >
      <div className="relative flex items-center">
        <TextInput
          ref={ref}
          className={`block w-full rounded-md shadow-sm disabled:cursor-not-allowed disabled:text-gray-400 sm:text-sm ${
            error
              ? 'border-red-300 focus:border-red-300 focus:ring-red-500'
              : 'focus:border-indigo-500 focus:ring-indigo-500 border-gray-300'
          } ${highlight && !error ? 'animate-highlight border-green-500' : ''}`}
          type={type}
          {...inputProps}
          data-testid={inputProps.id}
        />
      </div>
    </DefaultFormFieldLayout>
  );
});
